import React, { useState } from "react";
import { Image, Card, Button, Row, Col, Container } from "react-bootstrap";

import styled from "styled-components";
import { handleOnImg404 } from "../../utils";
import MiSelector from "./MiSelector";

const CustomRowCard = styled(Card)`
width: 65rem;
  
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  border: 0;
`;
/* cursor: pointer;*/

const CustomImgCard = styled(Card.Img)`
  object-fit: contain;
  height: 50px;
`;

const CustomCardTitle = styled(Card.Title)`
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  height: 1.563rem;
`;

const CustomCardText = styled(Card.Text)`
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  height: 1.563rem;
  margin-bottom: 0.25rem;
`;

const ImageWrapper = styled.div`
  height: ${({ height }) => height || "9.9rem"};
`;

// Componente genérico para cartas que tienen la imagen situada a la izquierda y el texto a la derecha
//  Recibe:
// title --> El título de la carta
// cardImage --> La img de la carta, src o fichero
// body --> un array de objetos para mostrar el texto de la carta, cada item del array será un objeto con un value y una imagen opcional a colocar
//

const RowCard = ({ title, cardImage, body = [], imgOnError, heightPhoto, ciudad='', id, accessLevel, content, ...props }) => {
  return (
    <CustomRowCard {...props}>
      
      <Row noGutters className="col-md-12">
        <Col className="col-md-1 mt-2">
          <cardImage height={heightPhoto}>
            <CustomImgCard src={cardImage.imagen} onClick={cardImage.onClick} onError={(e) => handleOnImg404(e, imgOnError)} />
          </cardImage>
          
        </Col>
        <Col className="col-md-5">
          <Card.Body>
            <CustomCardTitle title={title}>{title}</CustomCardTitle>
            
            {/* {buttons} */}
          </Card.Body>
        </Col>
        <Col className="col-md-3">
          {body.map((textItem, index) => {
              let img = textItem.img ? <Image className={"align-top mr-1"} title={textItem.img.title} src={textItem.img.url} height={textItem.img.size} onClick={textItem.img.onClick} /> : "";
              //console.log({ooooo:textItem.img})
              return (
                <CustomCardText key={index} title={textItem.value} >
                  {img}
                  {textItem.value}
                </CustomCardText>
              );
            })}        
        </Col>
        <Col className="col-md-3">
          {((content.type === 'Monja' &&
          content.sister?.destinations[0]?.province?.name 
            && !content.sister?.destinations[0]?.province?.name.toLowerCase().includes('suprimida') ) || 
            (content.type === 'Laico' &&
            content.destinationLaicos[0]?.province.name
            && !content.destinationLaicos[0]?.province.name.toLowerCase().includes('suprimida')
            ))
            && <>
              <CustomCardText>Nivel de acceso:</CustomCardText>
              <MiSelector title='Si cambia su rol por uno inferior perderá su nivel en el siguiente acceso a la aplicación' id={id} accessLevel={accessLevel}/>
            </>}
        </Col>
      </Row>
      <Row>
        <Col>
          <CustomCardText className={'ml-3'} title={content.email}><small>{content.email}</small></CustomCardText>
        </Col>
      
      </Row>
    </CustomRowCard >
  );
};

export default RowCard;
